<template>
  <div class="page-container">
    <NavBarAdmin />
    <div class="page-container-inner-wrapper">
      <div class="list row">
        <h3 class="table-headline">New asset</h3>
        <div class="page-content-wrapper">
          <div class="page-bubble" v-if="!submitted">
            <h3 class="table-headline">Fill out form to register asset</h3>
            <input
              type="hidden"
              v-model="asset.companyCode"
              placeholder="companyCode"
              readonly
            />
            <input
              type="hidden"
              v-model="asset.assetCode"
              placeholder="assetCode"
              readonly
            />
            <label for="assetType">Asset Type</label>
            <select v-model="asset.assetType" placeholder="Location Code">
              <option value="Generation">Generation</option>
              <option value="Load">Load</option>
              <option value="EV">EV</option>
            </select>
            <label for="assetName">Asset Name</label>
            <input type="text" v-model="asset.assetName" name="assetType" />
            <label for="capacity">Capacity (KWh)</label>
            <input
              type="text"
              v-model="asset.assetCapacity"
              name="assetCapacity"
            />
            <div class="checkbox-wrapper">
              <input
                type="checkbox"
                name="terms"
                value="Terms"
                class="checkbox"
              />
              <label for="terms" class="checkbox-label"
                >Is the asset address same as user address?</label
              >
            </div>
            <label v-if="showCountry" for="country">Country</label>
            <select v-if="showCountry" v-model="asset.assetCountry" placeholder="Country">
              <!-- <option selected="true" value="country" disabled>
                Select a Country
              </option>
              <option value="AT" label="Austria">Austria</option>
              <option value="BE" label="Belgium">Belgium</option>
              <option value="BG" label="Bulgaria">Bulgaria</option>
              <option value="HR" label="Croatia">Croatia</option>
              <option value="FR" label="France">France</option>
              <option value="DE" label="Germany">Germany</option>
              <option value="GR" label="Greece">Greece</option>
              <option value="HU" label="Hungary">Hungary</option>
              <option value="IT" label="Italy">Italy</option>
              <option value="LU" label="Luxembourg">Luxembourg</option>
              <option value="NL" label="Netherlands">Netherlands</option>
              <option value="PL" label="Poland">Poland</option>
              <option value="PT" label="Portugal">Portugal</option>
              <option value="RO" label="Romania">Romania</option>
              <option value="SE" label="Sweden">Sweden</option> -->

              <option
                v-for="country in countries"
                :value="country.countryCode"
                v-bind:key="country.countryCode"
                :selected="country.countryCode === 'BE' ? true : false"
              >{{ country.countryName }}</option>
            </select>
            <label for="address">Address</label>
            <input type="text" v-model="asset.assetAddress" name="assetType" />
            <label for="city">City</label>
            <input type="text" v-model="asset.assetCity" name="assetType" />
            <label for="postalCode">Postal Code</label>
            <input type="text" v-model="asset.assetPostCode" name="assetType" />
            <label for="long">Longitude</label>
            <input type="text" v-model="asset.assetLong" name="long" />
            <label for="lat">Latitude</label>
            <input type="text" v-model="asset.assetLat" name="lat" />
            <button class="request-button" @click="saveAsset">Save</button>
          </div>
          <div class="page-bubble" v-if="submitted">
            <h4>You submitted successfully!</h4>
            <button class="btn btn-success" @click="newAsset">Add</button>
          </div>
          <div class="page-bubble page-upload-wrapper">
            <form enctype="multipart/form-data">
              <h3 class="table-headline">Upload assets from Excel file.</h3>
              <input type="file" name="file" class="file-button" />
              <button class="request-button" v-on:click="importAssets">
                Import
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CountryDataService from "../../services/CountryDataService";
import AssetDataService from "../../services/AssetDataService";
import NavBarAdmin from "../../components/Common/NavBarAdmin";

export default {
  name: "add-asset",
  components: { NavBarAdmin },
  data() {
    return {
      asset: {
        id: null,
        companyCode: this.$store.state.auth.user.companyCode,
        assetCode: "",
        assetType: "",
        assetName: "",
        assetCapacity: "",
        assetAddress: "",
        assetCity: "",
        assetPostCode: "",
        assetCountry: this.$store.state.auth.user.countryCode,
        assetLong: "",
        assetLat: "",
      },
      submitted: false,

      countries: [],

      selectedFiles: undefined,
      currentFile: undefined,
      progress: 0,
      message: "",

      fileInfos: [],
    };
  },

  methods: {

    retrieveCountries() {
      /* 
      CountryDataService.getAll()
        .then((response) => {
          this.countries = response.data;
          console.log("HERE... load countries sucessfull: " + response.data);
        })
        .catch((e) => {
          console.log("HERE... load countries error: " + e);
        });
       */
      console.log("HERE... currentUser's role: " + this.$store.state.auth.user.roles);
      console.log("HERE... currentUser's country: " + this.$store.state.auth.user.countryCode);
      if (this.$store.state.auth.user.roles == "ROLE_ADMIN") {
        CountryDataService.getAll()
        .then((response) => {
          this.countries = response.data;
          console.log("HERE... load countries sucessfull: " + response.data);
        })
        .catch((e) => {
          console.log("HERE... load countries error: " + e);
        });
      } else {
        CountryDataService.findByCountryCode(this.$store.state.auth.user.countryCode)
        .then((response) => {
          this.countries = response.data;
          console.log("HERE... load country sucessfull: " + this.countries.countryCode);
        })
        .catch((e) => {
          console.log("HERE... load country error: " + e);
        });
      }
    },

    saveAsset() {
      var data = {
        companyCode: this.asset.companyCode,
        assetCode: this.asset.assetCode,
        assetType: this.asset.assetType,
        assetName: this.asset.assetName,
        assetCapacity: this.asset.assetCapacity,
        assetAddress: this.asset.assetAddress,
        assetCity: this.asset.assetCity,
        assetPostCode: this.asset.assetPostCode,
        assetCountry: this.asset.assetCountry,
        assetLong: this.asset.assetLong,
        assetLat: this.asset.assetLat,
      };

      AssetDataService.create(data)
        .then((response) => {
          this.asset.id = response.data.id;
          console.log(response.data);
          this.submitted = true;
          this.$router.push({ name: "assets" });
        })
        .catch((e) => {
          console.log(e);
        });
    },

    importAssets() {
      var data = {
        companyCode: this.asset.companyCode,
        assetCode: this.asset.assetCode,
        assetType: this.asset.assetType,
        assetName: this.asset.assetName,
        assetCapacity: this.asset.assetCapacity,
        assetAddress: this.asset.assetAddress,
        assetCity: this.asset.assetCity,
        assetPostCode: this.asset.assetPostCode,
        assetCountry: this.asset.assetCountry,
      };

      AssetDataService.import(data)
        .then((response) => {
          this.asset.id = response.data.id;
          console.log(response.data);
          this.submitted = true;
          this.$router.push({ name: "assetsAdmin" });
        })
        .catch((e) => {
          console.log(e);
        });
    },

    newAsset() {
      this.submitted = false;
      this.asset = {};
    },

    selectFile() {
      this.selectedFiles = this.$refs.file.files;
    },

    upload() {
      this.progress = 0;

      this.currentFile = this.selectedFiles.item(0);
      UploadService.upload(this.currentFile, (event) => {
        this.progress = Math.round((100 * event.loaded) / event.total);
      })
        .then((response) => {
          this.message = response.data.message;
          return UploadService.getFiles();
        })
        .then((files) => {
          this.fileInfos = files.data;
        })
        .catch(() => {
          this.progress = 0;
          this.message = "Could not upload the file!";
          this.currentFile = undefined;
        });

      this.selectedFiles = undefined;
    },
  },

  computed: {

    currentUser() {
      return this.$store.state.auth.user;
    },

    showCountry() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes("ROLE_ADMIN");
      }

      return false;
    },
  },

  mounted() {
    this.$store.state.auth.user;
    this.retrieveCountries();
    UploadService.getFiles().then((response) => {
      this.fileInfos = response.data;
    });
  },
};
</script>

<style lang="scss">
@import "../../sass/main.scss";

.nav-bar {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  margin-top: -100px;
  margin-left: -10px;
}

.page-container {
  min-height: 100vh;
  background: #e6e8f0;
}

.page-container-inner-wrapper {
  padding: 40px;
  max-width: 1300px;
  margin: 0 auto;
}

.page-content-wrapper {
  width: 100%;
  display: flex;
}

.page-upload-wrapper {
  width: 35% !important;
  height: 225px;
}

.page-bubble label {
  display: block;
  font-size: 0.9em;
  margin: 0 0 3px 5px;
}

.page-bubble input,
.page-bubble select {
  width: 100%;
  padding: 6px 10px;
  border-radius: 10px;
  border: 1px solid #ccc;
  margin-bottom: 20px;
}

// input::-webkit-calendar-picker-indicator {
//   color: rgba(0, 0, 0, 0) !important;
// }

.page-bubble input:focus,
.page-bubble select:focus {
  outline: none;
  border: 1px solid #6680a0;
  box-shadow: 0 0 5px #c8d2da;
}

.file-button {
  border: none !important;
  padding: 0 !important;
  border-radius: 0 !important;
  margin-bottom: 0 !important;
  font-size: 0.9rem;
  color: #393b3e;
  padding: 5px 15px;
  background: #fff;
  cursor: pointer;
}

.submit-form {
  max-width: 400px;
  margin: auto;
}

.request-button {
  padding: 5px 15px;
  border: none;
  font-size: 1rem;
  color: white;
  background: #146bd4;
  margin-top: 20px;
}

.checkbox-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 20px 0 20px 5px;
  flex: 1;
}

.checkbox {
  width: auto !important;
  margin-bottom: 0 !important;
}

.checkbox-label {
  margin: 0 0 0 10px !important;
}
</style>